import { render, staticRenderFns } from "./AegisShipment.vue?vue&type=template&id=7533cdc5&"
import script from "./AegisShipment.vue?vue&type=script&lang=js&"
export * from "./AegisShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports